import { OpusUserObject } from './authHelper'

export type AuthData = {
    amr: string[]
    auth_time: number
    email?: string
    family_name: string
    given_name: string
    idp: string
    name: string
    sid: string
    sub: string
    opus_contact_id: any[]
    opus_user: OpusUserObject
    opus_user_id: string
    publishinghousegroup_id: string
    token: string
}

export type Authentication = {
    isAuthenticated: boolean
    isAuthenticating: boolean
    statusText: null | string
    publishingHouse: Record<string, unknown>
    data: AuthData | null | undefined
    token?: any
    userName?: any
}

export const initialAuth: Authentication = {
    isAuthenticated: false,
    isAuthenticating: false,
    statusText: null,
    publishingHouse: {},
    data: undefined,
}
